<div class="page-container">
  <div class="header p-lg">
    <h1>{{ 'auth.onboarding.welcome' | translate:{organizationName: organizationName()} }}</h1>
    <p class="subtitle">{{ 'auth.onboarding.subtitle' | translate }}</p>
  </div>

  <div class="steps scrollable-content">
    <h2 class="m-lg">{{ 'auth.onboarding.quickStart' | translate }}</h2>

    @for (step of steps(); track step.id) {
    <div class="step m-sm" [class.completed]="step.completed" [class.disabled]="!step.enabled">
      <div class="step-icon">
        @if (step.completed) {
        <span class="checkmark">✓</span>
        } @else {
        <span class="number">{{ $index + 1 }}</span>
        }
      </div>
      <div class="step-content">
        <h3>{{ step.title }}</h3>
        <p>{{ step.description }}</p>
        @if (!step.completed) {
        <button type="button" class="btn-action" [disabled]="!step.enabled" (click)="handleAction(step)"
          [attr.data-testid]="'onboarding-action-' + step.id">
          {{ step.actionLabel }}
        </button>
        }
      </div>
    </div>
    }
  </div>

  <div class="actions">
    <button type="button" class="btn-secondary" (click)="skipOnboarding()" data-testid="onboarding-skip-btn">
      {{ 'auth.onboarding.skip' | translate }}
    </button>
  </div>
</div>